import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import constants from "../../../../constants";
import AlertContext from "../../../../context/AlertContext";
import Button from "../../../Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Popover,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import DownloadOptions from "./WidgetMenu/DownloadOptions";
import Loading from "../../../Notification-Loading/Loading/Loading";
import PaginationCustom from "./PaginationCustom";
import Select from "react-select";
import {
  isAfter,
  startOfWeek,
  subWeeks,
  startOfMonth,
  subMonths,
  format,
  isToday,
  isSameDay,
} from "date-fns";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import { Columns3 } from "lucide-react";
import { TreeSelect } from "antd";
// import "antd/dist/reset.css";
import { getDataFromStorage } from "../../../../util";
import ApplyFilters from "../../../CommonComponents/ApplyFilters";
import Search from "../../../CommonComponents/Search";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import InputDropdown from "../../../CommonComponents/InputDropdown";

import NameCell from "../../../CommonComponents/NameCell";
import { UserReportProvider } from "../../../../context/UserReportContext";

export const getCol = (col) => {
  if (col == "Name") {
    return "name";
  } else if (col == "Email address") {
    return "email";
  } else if (col == "Branch") {
    return "branch";
  } else if (col == "College") {
    return "college";
  } else if (col == "Completed") {
    return "completedCount";
  } else if (col == "Pending") {
    return "pendingCount";
  } else if (col == "Overdue") {
    return "dueDateCount";
  } else if (col == "Selected range(%)") {
    return "percentage_selected_duration";
  } else if (col == "From Start(%)") {
    return "percentage_total_duration";
  } else return col;
};

export const getDisplayStatus = (n, t, d) => {
  let returnSvg = "Overdue";
  const dueDate = new Date(d);
  const currentDate = new Date();
  if (t == constants.libTypeIds.ASSIGNMENT) {
    if (n == 0 || n == 1 || n == 3 || n == 6) {
      if (dueDate < currentDate) {
        returnSvg = "Overdue";
      } else {
        returnSvg = "pending";
      }
    } else {
      returnSvg = "completed";
    }
  } else if (
    t == constants.libTypeIds.MCQ ||
    t == constants.libTypeIds.MCQ_MULTI ||
    t == constants.libTypeIds.MCQ_SINGLE ||
    t == constants.libTypeIds.SQL
  ) {
    if (n == 0 || n == 1 || n == 3 || n == 6 || n == 7) {
      if (dueDate < currentDate) {
        returnSvg = "Overdue";
      } else {
        returnSvg = "pending";
      }
    } else if (n == 2) {
      returnSvg = "completed";
    }
  } else if (
    t == constants.libTypeIds.DESCRIPTIVE ||
    t == constants.libTypeIds.CODING_SNIPPET ||
    t == constants.libTypeIds.SAQ ||
    t == constants.libTypeIds.LAQ
  ) {
    if (n == 0 || n == 1 || n == 3 || n == 6 || n == 7) {
      if (dueDate < currentDate) {
        returnSvg = "Overdue";
      } else {
        returnSvg = "pending";
      }
    } else if (n == 2 || n == 4 || n == 5) {
      returnSvg = "completed";
    }
  } else if (t == constants.libTypeIds.CODING_CHALLENGE) {
    if (n == 0 || n == 1 || n == 3 || n == 6 || n == 7) {
      if (dueDate < currentDate) {
        returnSvg = "Overdue";
      } else {
        returnSvg = "pending";
      }
    } else if (n == 2 || n == 4) {
      returnSvg = "completed";
    }
  }
  return returnSvg;
};

const Attendance = (Props) => {
  // console.log("Props", Props);
  const axios = useAxiosPrivate();
  const Alert = useContext(AlertContext);
  const [page, setPage] = useState(1);
  const [showDownloadOptionsDropDown, setShowDownloadOptionsDropDown] =
    useState(false);
  const [widgetColumns1, setWidgetColumns1] = useState([]);
  const [widgetColumns2, setWidgetColumns2] = useState([]);
  const [headerColumns, setHeaderColumns] = useState([]);
  const [widgetColumns3, setWidgetColumns3] = useState([]);
  const [widgetData, setWidgetData] = useState([]);
  const [totalDataCount, setDataTotalCount] = useState(0);
  const [orientation, setOrientation] = useState("landscape");
  const [orderby, setOrderby] = useState("ASC");
  const [sortby, setSortby] = useState("name");
  const [appliedFilters, setAppliedFilters] = useState({
    college: null,
    branch: null,
    startDate: null,
    endDate: null,
    assignmentIds: [],
    search: "",
  });
  // const [render, setRender] = useState(false);
  const { downloadWidget, setIsUnAuth, setShowNotify, collegeList, setCollegeList, branchList, setBranchList } =
    useContext(AlertContext);
  // const onpaginationChange = (e, page) => {
  //   setPage(page);
  // };

  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // const [collegeList, setCollegeList] = useState([]);
  // const [branchList, setBranchList] = useState([]);
  const [college, setCollege] = useState({ label: "All", value: 0 });
  const defaultCollegeRef = useRef(null);
  const [branch, setBranch] = useState(null);
  const [testList, setTestList] = useState([]);
  const [assignmentIds, setAssignmentIds] = useState([]);
  const [value, setValue] = useState([]);
  const assignList = useRef([]);

  const limit = Props.batchDashboard
    ? parseInt(Props.data.type) === 1
      ? 8
      : 9
    : 10;

  // New state for column visibility
  const [columnVisibility, setColumnVisibility] = useState({
    name: true,
    email: false,
    branch: false,
    college: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  // Add state for tracking filter changes and apply functionality
  const [filtersApplied, setFiltersApplied] = useState(true);
  const [filtersProcessed, setFiltersProcessed] = useState(false); // to track if filters have been processed
  const [isLoading, setIsLoading] = useState(false);
  // NEW: Search states
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 500);

  useEffect(() => {
    setPage(1);
    setWidgetColumns1([]);
    setWidgetColumns2([]);
    setHeaderColumns([]);
    setWidgetColumns3([]);
    setWidgetData([]);
    setDataTotalCount(0);
    setOrientation("landscape");
    setOrderby("ASC");
    setSortby("name");
    setSearchTerm("");
    setTestList([]);
    setAssignmentIds([]);
    setValue([]);
    assignList.current = [];
    setFiltersApplied(true);
    setFiltersProcessed(false);
  }, [Props.data.type, Props.batchId]);

  // Toggle column visibility
  const handleToggleColumn = (column) => {
    if (column !== "name") {
      setColumnVisibility((prev) => ({
        ...prev,
        [column]: !prev[column],
      }));
    }
  };

  // Handle click on settings icon
  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle close of popover
  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  const handleSettingClose = () => {
    setAnchorE2(null);
  };

  const handleApplyClose = () => {
    if (!startDate || !endDate) {
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: "Please select both start and end dates.",
      });
    }
    setAnchorE2(null);
  };

  const handleCancelClose = () => {
    setStartDate(null);
    setEndDate(null);
    setAnchorE2(null);
  };

  // Filter widgetColumns1 based on visibility settings
  const getVisibleColumns = () => {
    const columns = [];
    if (columnVisibility.name) columns.push("Name");
    if (columnVisibility.email) columns.push("Email address");
    if (columnVisibility.branch) columns.push("Branch");
    if (columnVisibility.college) columns.push("College");
    return columns;
  };

  const handleResponse = (title, msg) => {
    setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  // Initialize dates based on batch dashboard
  useEffect(() => {
    if (Props.batchDashboard) {
      const batStartDate = Props.batchStartDate
        ? new Date(Props.batchStartDate)
        : new Date();
      const today = new Date();
      // const batStartDate = startOfWeek(today, { weekStartsOn: 1 });

      setStartDate(batStartDate);
      setEndDate(today);

      // Set default date range to "From Start"
      setDateRange({ value: "fromStart", label: "From Start" });
      // Auto-apply filters on initial load
      // setFiltersApplied(true);
      setAppliedFilters({
        college: { label: "All", value: 0 },
        branch: null,
        startDate: batStartDate,
        endDate: today,
        assignmentIds: [],
        search: "",
      });
    }
  }, [Props.batchDashboard, Props.batchStartDate]);

  useEffect(() => {
    if (!filtersProcessed) return;
    // Reset pagination and trigger data fetch
    setPage(1);
    setFiltersApplied(true);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (Props.batchDashboard) {
      try {
        const responseOfColleges = async () => {
          let response = await axios.get("node/admin/batch/college", {
            params: {
              id: Props.batchId,
              filter:true,
            },
            headers: { "Content-type": "application/json" },
          });
          const transformedData = response.data.data.map((item, index) => {
            return { label: item.name, value: index + 1 };
          });
          const allOption = { label: "All", value: 0 };
          const list = [allOption, ...transformedData];
          console.log("college list", list);
          setCollegeList(list);
          defaultCollegeRef.current = allOption;
          setCollege(allOption);

        };

        responseOfColleges();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, []);

  useEffect(() => {
    console.log("college changed", college);
    console.log("branch changed", branch);
    if (Props.batchDashboard) {
      try {
        const responseOfBranches = async () => {
          let response = await axios.get("node/admin/batch/college/branch", {
            params: {
              id: Props.batchId,
              cname: college?.label,
            },
            headers: {
              "Content-type": "application/json",
            },
          });
          const transformedData = response?.data?.data?.map((item, index) => {
            return { label: item.branch, value: index + 1 };
          });
          const allOption = { label: "All", value: 0 };
          setBranchList([allOption, ...transformedData]);
          if (college?.value !== 0) setBranch(allOption);
        };

        responseOfBranches();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, [college]);

  const formatTreeData = (data) => {
    return data.map((lp) => ({
      title: lp.lpname,
      value: `lp-${lp.lpid}`,
      children: lp.modules.map((mod) => ({
        title: mod.mname,
        value: `mod-${mod.mid}`,
        children: mod.mconfig.map((cfg) => ({
          title: cfg.name,
          value: String(cfg.lpcid),
          isLeaf: true,
        })),
      })),
    }));
  };

  // Utility: flatten selected values into assignment IDs only
  const extractAssignments = (selected, tree = testList) => {
    let result = [];

    const traverse = (nodes, parentSelected = false) => {
      for (const node of nodes) {
        const isSelected = selected.includes(node.value) || parentSelected;

        if (node.isLeaf) {
          if (isSelected) {
            result.push(Number(node.value));
          }
        } else if (node.children) {
          traverse(node.children, isSelected); // 👈 pass parentSelected down
        }
      }
    };

    traverse(tree);
    return [...new Set(result)];
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    const aIdsss = extractAssignments(newValue);
    setAssignmentIds(aIdsss);
  };

  // const assignmentParams = ()=> {
  //   let params = {};
  //   if (startDate && endDate) {
  //     params.sd = format(startDate, 'yyyy-MM-dd');
  //     params.ed = format(endDate, 'yyyy-MM-dd HH:mm:ss');
  //   }
  //   return params;
  // }

  function sortLearningPathData(data) {
    return data
      .sort((a, b) => a.lpid - b.lpid)
      .map((learningPath) => ({
        ...learningPath,
        modules: learningPath.modules
          .sort((a, b) => a.morderno - b.morderno)
          .map((module) => ({
            ...module,
            mconfig: module.mconfig.sort((a, b) => a.orderno - b.orderno),
          })),
      }));
  }

  useEffect(() => {
    // node/admin/batch/:id/assignments
    if (Props?.batchDashboard && parseInt(Props?.data?.type) === 4) {
      try {
        setTestList([]);
        const assignmentResponse = async () => {
          let response = await axios.get(
            `node/admin/batch/${Props.batchId}/assignments`,
            {
              // params: assignmentParams(),
              headers: {
                "Content-type": "application/json",
              },
            }
          );

          if (response?.data?.data && response.data.data.length > 0) {
            let data = JSON.parse(
              typeof response.data.data === "string" ? response.data.data : "[]"
            );
            const sortedData = sortLearningPathData(data);
            const transformedData = formatTreeData(sortedData);

            setTestList(transformedData);
            setValue(transformedData.map((lp) => lp.value)); // Select all by default
            assignList.current = transformedData;
            setValue(transformedData.map((lp) => lp.value)); // Select all by default
            const aIds = extractAssignments(transformedData);
            setAssignmentIds(aIds);
          }
        };
        assignmentResponse();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, [Props?.data?.type, Props?.batchId]);

  const handleInputChange = (value, name) => {
    if (name === "dateRange") {
      setDateRange(value);
      if (!value || value === null || value === undefined) {
        setStartDate(null);
        setEndDate(null);
      }

      if (value && value.value === "custom") {
        setAnchorE2(document.body); // Open popover for custom date selection
      }

      // Handle predefined date ranges
      if (value && value.value !== "custom") {
        const today = new Date();
        const batStartDate = Props.batchStartDate
          ? new Date(Props.batchStartDate)
          : new Date();

        let newStartDate = batStartDate;
        let newEndDate = today;

        switch (value.value) {
          case "thisWeek":
            newStartDate = startOfWeek(today, { weekStartsOn: 1 });
            break;
          case "lastWeek":
            newStartDate = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 1);
            newEndDate = startOfWeek(today, { weekStartsOn: 1 });
            break;
          case "last2Weeks":
            newStartDate = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 2);
            break;
          case "thisMonth":
            newStartDate = startOfMonth(today);
            break;
          case "lastMonth":
            newStartDate = startOfMonth(subMonths(today, 1));
            newEndDate = startOfMonth(today);
            break;
          case "last3Months":
            newStartDate = startOfMonth(subMonths(today, 3));
            break;
          case "fromStart":
            newStartDate = batStartDate;
            break;
          default:
            break;
        }

        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }
    } else if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else if (name === "college") {
      setCollege(value);
      if (value?.value !== 0 && (!branch)) {
        setBranch({ label: "All", value: 0 });
      }
      if (value?.value === 0) setBranch(null);
    } else if (name === "branch") {
      setBranch(value);
    }

    // Mark filters as not applied when user makes changes
    setFiltersApplied(false);
  };

  // Apply filters handler
  const handleApplyFilters = () => {
    setPage(1); // Reset to first page when applying new filters
    if (college === null) setCollege({ label: "All", value: 0 });//to retain college filter after data fetch
    else if (college.value !== 0 && (!branch || branch.value === null)) setBranch({ label: "All", value: 0 });

    if (value.length === 0) setValue(assignList.current.map((lp) => lp.value));//to retain assignment filter after data fetch
    setFiltersApplied(true);
    setAppliedFilters({
      college,
      branch,
      startDate,
      endDate,
      assignmentIds,
      search: debouncedSearchTerm?.trim(),
    });
  };

  // Reset filters handler
  const handleResetFilters = () => {
    if (Props.batchDashboard) {
      const today = new Date();
      const batStartDate = Props.batchStartDate
        ? new Date(Props.batchStartDate)
        : new Date();

      setDateRange({ value: "fromStart", label: "From Start" });
      // setDateRange(null);
      setStartDate(batStartDate);
      setEndDate(today);
      setCollege({ label: "All", value: 0 });
      if (collegeList.length === 2) setBranch({ label: "All", value: 0 });
      else setBranch(null);
      // setCollege(defaultCollegeRef.current || { label: "All", value: 0 });
      // setBranch(null);
      setValue(assignList.current.map((lp) => lp.value)); // Select all by default
      setAssignmentIds([]);

      // Apply the reset filters
      setPage(1);
      setSearchTerm(""); // Reset search too

      setFiltersApplied(true);
      setWidgetData([]);
      setFiltersProcessed(false);
      setAppliedFilters({
        college: { label: "All", value: 0 },
        branch: null,
        startDate: batStartDate,
        endDate: today,
        assignmentIds: [],
        search: "",
      });
    }
  };

  // Generate date ranges based on batch start date
  const getDateRanges = () => {
    if (!Props.batchStartDate) return [];

    const batStartDate = new Date(Props.batchStartDate);
    const today = new Date();
    const ranges = [];

    // This Week
    const thisWeekStart = startOfWeek(today, { weekStartsOn: 1 });
    if (
      isAfter(thisWeekStart, batStartDate) ||
      thisWeekStart.getTime() === batStartDate.getTime()
    ) {
      ranges.push({ value: "thisWeek", label: "This Week" });
    }
    // Last Week
    const lastWeekStart = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 1);
    if (isAfter(lastWeekStart, batStartDate)) {
      ranges.push({ value: "lastWeek", label: "Last Week" });
    }

    // Last 2 Weeks
    const last2WeeksStart = subWeeks(
      startOfWeek(today, { weekStartsOn: 1 }),
      2
    );
    if (isAfter(last2WeeksStart, batStartDate)) {
      ranges.push({ value: "last2Weeks", label: "Last 2 Weeks" });
    }

    // This Month
    const thisMonthStart = startOfMonth(today);
    if (
      isAfter(thisMonthStart, batStartDate) ||
      thisMonthStart.getTime() === batStartDate.getTime()
    ) {
      ranges.push({ value: "thisMonth", label: "This Month" });
    }

    // Last Month
    const lastMonthStart = startOfMonth(subMonths(today, 1));
    if (isAfter(lastMonthStart, batStartDate)) {
      ranges.push({ value: "lastMonth", label: "Last Month" });
    }

    // Last 3 Months
    const last3MonthsStart = startOfMonth(subMonths(today, 3));
    if (isAfter(last3MonthsStart, batStartDate)) {
      ranges.push({ value: "last3Months", label: "Last 3 Months" });
    }

    // From Start
    ranges.push({ value: "fromStart", label: "From Start" });

    // Custom (always allow)
    ranges.push({ value: "custom", label: "Custom" });

    return ranges;
  };

  const dateRanges = getDateRanges();

  const getStyles = makeStyles({
    combined2: {
      maxWidth: "270px",
      minWidth: "270px",
      position: "sticky",
      right: "200px",
      background: "#f9fafb",
      borderBottom: "none",
      //styleName: Text sm/Medium;
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      // textAlign: "left",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224)",
    },
    combined1: {
      maxWidth: "200px",
      minWidth: "200px",
      position: "sticky",
      right: 0,
      background: "#f9fafb",
      borderBottom: "none",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      // textAlign: "left",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224), inset 0 -1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellSelected: {
      maxWidth: "100px",
      minWidth: "100px",
      position: "sticky",
      right: 0,
      background: "#ffffff",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224), inset 0 0px 0 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224)",

      //  boxShadow:"inset -1px 0 0 0 rgb(224, 224, 224"
    },
    stickyCellSelected1: {
      maxWidth: "100px",
      minWidth: "100px",
      position: "sticky",
      right: 0,
      background: "#f9fafb",
      // borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224)",
    },
    stickyCellTotal: {
      maxWidth: "100px",
      minWidth: "100px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "100px"
          : 0
        }`,
      background: "#ffffff",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224), inset 0 0px 0 0 rgb(224, 224, 224)",
      // boxShadow:"inset -1px 0 0 0 rgb(224, 224, 224"

      // textOverflow: "ellipsis",
      // overflow: "hidden",

      // whiteSpace: "nowrap",
    },

    stickyCellTotal1: {
      maxWidth: "100px",
      minWidth: "100px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "100px"
          : 0
        }`,
      background: "#f9fafb",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",

      // textOverflow: "ellipsis",
      // overflow: "hidden",
      // textWrap: "nowrap",
      // whiteSpace: "nowrap",
    },
    stickyCellname1: {
      maxWidth: "150px",
      minWidth: "150px",
      position: "sticky",
      left: 0,
      background: "#f9fafb",
      textOverflow: "ellipsis",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      overflow: "hidden",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellcompleted1: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "380px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "380px"
            : "200px"
        } `,
      background: "#f9fafb",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224)",
    },
    stickyCellpending1: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "290px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "290px"
            : "100px"
        } `,
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#f9fafb",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#F79009",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",

      // maxHeight:"40px",
      // textOverflow:"ellipsis",
      // overflow:"hidden",
    },

    stickyCelloverdue1: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "200px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "200px"
            : 0
        } `,
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#f9fafb",
      maxHeight: "40px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#F04438",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellemail1: {
      position: "sticky",
      //left: "150px",
      left: `${widgetData[0]?.hasOwnProperty("name") ? "150px" : 0} `,
      maxWidth: "150px",
      minWidth: "150px",
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#f9fafb",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellbranch1: {
      position: "sticky",
      // left: "300px",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? "300px"
            : "150px"
          : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      //zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#f9fafb",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      whiteSpace: "nowrap",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellcollege1: {
      position: "sticky",
      // left: "450px",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "450px"
              : "300px"
            : "300px"
          : getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "300px"
              : "150px"
            : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#f9fafb",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      whiteSpace: "nowrap",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellname: {
      position: "sticky",
      left: 0,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#101828",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    stickyCellcompleted: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      // right: "300px",
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "380px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "380px"
            : "200px"
        } `,
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#ffffff",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow:
        "inset -1px 0px 0px 0 rgb(224, 224, 224), inset 1px 0 0 0 rgb(224, 224, 224)",
      // height:"40px",
      // textOverflow:"ellipsis",
      // overflow:"hidden",
    },
    stickyCellpending: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "290px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "290px"
            : "100px"
        } `,
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#ffffff",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
      // maxHeight:"40px",
      // textOverflow:"ellipsis",
      // overflow:"hidden",
    },

    stickyCelloverdue: {
      maxWidth: "90px",
      minWidth: "90px",
      position: "sticky",
      //right: 0,
      right: `${widgetData[0]?.hasOwnProperty("percentage_total_duration") &&
          widgetData[0]?.hasOwnProperty("percentage_selected_duration")
          ? "200px"
          : widgetData[0]?.hasOwnProperty("percentage_total_duration") ||
            widgetData[0]?.hasOwnProperty("percentage_selected_duration")
            ? "200px"
            : 0
        } `,
      background: "#ffffff",
      maxHeight: "40px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    stickyCellemail: {
      position: "sticky",
      left: `${getVisibleColumns().includes("Name") ? "150px" : 0} `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    stickyCellbranch: {
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      position: "sticky",
      // left: "300px",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? "300px"
            : "150px"
          : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
    },
    stickyCellcollege: {
      position: "sticky",
      // left: "450px",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "450px"
              : "300px"
            : "300px"
          : getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "300px"
              : "150px"
            : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      // zIndex: 1, // Ensure the sticky columns stay on top during scrollin
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    na: {
      // maxHeight:"40px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: "150px",
      minWidth: "150px",
      textWrap: "nowrap",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      whiteSpace: "nowrap",
      padding: "9px !important",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    nah: {
      // maxHeight:"40px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: "150px",
      minWidth: "150px",
      textWrap: "nowrap",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      whiteSpace: "nowrap",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
  });

  const getAttForTitle = (s) => {
    if (s === "N/A") {
      return "Not Applicable";
    } else if (s == 1) {
      return "Present";
    } else {
      return "Absent";
    }
  };

  const getAtt = (s) => {
    if (s === "N/A") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#667085"
          />
          <path
            d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
            stroke="white"
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    } else if (s == 1) {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62135C15.7361 9.52257 15.7012 9.42782 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98221 14.9769 8.97991 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
            fill="#12B76A"
          />
        </svg>
      );
    } else {
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 0.25C4.615 0.25 0.25 4.615 0.25 10C0.25 15.385 4.615 19.75 10 19.75C15.385 19.75 19.75 15.385 19.75 10C19.75 4.615 15.385 0.25 10 0.25ZM8.28 7.22C8.21134 7.14631 8.12854 7.08721 8.03654 7.04622C7.94454 7.00523 7.84522 6.98318 7.74452 6.98141C7.64382 6.97963 7.54379 6.99816 7.4504 7.03588C7.35701 7.0736 7.27218 7.12974 7.20096 7.20096C7.12974 7.27218 7.0736 7.35701 7.03588 7.4504C6.99816 7.54379 6.97963 7.64382 6.98141 7.74452C6.98318 7.84522 7.00523 7.94454 7.04622 8.03654C7.08721 8.12854 7.14631 8.21134 7.22 8.28L8.94 10L7.22 11.72C7.14631 11.7887 7.08721 11.8715 7.04622 11.9635C7.00523 12.0555 6.98318 12.1548 6.98141 12.2555C6.97963 12.3562 6.99816 12.4562 7.03588 12.5496C7.0736 12.643 7.12974 12.7278 7.20096 12.799C7.27218 12.8703 7.35701 12.9264 7.4504 12.9641C7.54379 13.0018 7.64382 13.0204 7.74452 13.0186C7.84522 13.0168 7.94454 12.9948 8.03654 12.9538C8.12854 12.9128 8.21134 12.8537 8.28 12.78L10 11.06L11.72 12.78C11.7887 12.8537 11.8715 12.9128 11.9635 12.9538C12.0555 12.9948 12.1548 13.0168 12.2555 13.0186C12.3562 13.0204 12.4562 13.0018 12.5496 12.9641C12.643 12.9264 12.7278 12.8703 12.799 12.799C12.8703 12.7278 12.9264 12.643 12.9641 12.5496C13.0018 12.4562 13.0204 12.3562 13.0186 12.2555C13.0168 12.1548 12.9948 12.0555 12.9538 11.9635C12.9128 11.8715 12.8537 11.7887 12.78 11.72L11.06 10L12.78 8.28C12.8537 8.21134 12.9128 8.12854 12.9538 8.03654C12.9948 7.94454 13.0168 7.84522 13.0186 7.74452C13.0204 7.64382 13.0018 7.54379 12.9641 7.4504C12.9264 7.35701 12.8703 7.27218 12.799 7.20096C12.7278 7.12974 12.643 7.0736 12.5496 7.03588C12.4562 6.99816 12.3562 6.97963 12.2555 6.98141C12.1548 6.98318 12.0555 7.00523 11.9635 7.04622C11.8715 7.08721 11.7887 7.14631 11.72 7.22L10 8.94L8.28 7.22Z"
            fill="#F04438"
          />
        </svg>
      );
    }

    // present

    // Na

    // absent
  };

  const classes = getStyles();

  const getStatusForTitle = (n, t, d) => {
    return getDisplayStatus(n, t, d);
  };

  const getStatus = (n, t, d) => {
    let returnSvg = getDisplayStatus(n, t, d);
    if (returnSvg === "completed") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62135C15.7361 9.52257 15.7012 9.42782 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98221 14.9769 8.97991 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
            fill="#12B76A"
          />
        </svg>
      );
    } else if (returnSvg === "pending") {
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.25"
            y="0.25"
            width="19.5"
            height="19.5"
            rx="9.75"
            fill="#FEC84B"
          />
          <path
            d="M10.67 15.0025C11.0043 14.9583 11.2683 15.285 11.1551 15.6027C11.0959 15.7637 10.9584 15.8768 10.7877 15.8994C10.3951 15.9499 9.99849 15.9619 9.60352 15.9353C8.14636 15.8372 6.83534 15.2058 5.86414 14.2346C4.80506 13.1755 4.1499 11.7123 4.1499 10.0964C4.1499 8.4803 4.80506 7.01731 5.86414 5.95824C6.92321 4.89917 8.38619 4.24401 10.0023 4.24401C10.5626 4.24401 11.1087 4.32465 11.6291 4.47498C12.0561 4.59818 12.4675 4.76999 12.8553 4.98704L12.7399 4.68498C12.6437 4.43186 12.7707 4.14868 13.0236 4.05219C13.2767 3.95593 13.5599 4.08296 13.6564 4.33607L14.144 5.6119C14.1623 5.66044 14.173 5.71155 14.1757 5.76339C14.2139 6.00113 14.0715 6.23676 13.8347 6.30855L12.5288 6.70803C12.2703 6.78634 11.9974 6.64044 11.9191 6.3822C11.8408 6.12395 11.9867 5.8508 12.2449 5.77248L12.3523 5.73962C12.0428 5.57209 11.7162 5.43832 11.3781 5.34061C10.9453 5.21568 10.4838 5.14855 10.0023 5.14855C8.63604 5.14855 7.3989 5.70233 6.50368 6.59779C5.60822 7.49301 5.05445 8.72991 5.05445 10.0964C5.05445 11.4627 5.60822 12.6996 6.50368 13.595C7.315 14.4063 8.40693 14.9373 9.62146 15.0296C9.96874 15.0559 10.326 15.0473 10.67 15.0025ZM9.10638 7.71606C9.10638 7.46644 9.30892 7.2639 9.55877 7.2639C9.80839 7.2639 10.0109 7.46644 10.0109 7.71606V10.4691L11.8953 11.2974C12.1237 11.3979 12.2272 11.6645 12.1267 11.8929C12.0263 12.1211 11.7597 12.2248 11.5312 12.1244L9.39958 11.1874C9.22827 11.1228 9.10638 10.9576 9.10638 10.7639V7.71606ZM12.2458 14.5192C11.8818 14.7054 11.9303 15.2393 12.3225 15.3566C12.436 15.3887 12.5491 15.3789 12.6549 15.326C12.9467 15.1794 13.2268 15.0067 13.4895 14.8128C13.6177 14.7173 13.6843 14.5667 13.6706 14.4075C13.6356 14.0558 13.2352 13.8775 12.9506 14.0863C12.7285 14.2504 12.4927 14.3952 12.2458 14.5192ZM14.0908 12.8981C13.8848 13.2053 14.1162 13.6183 14.4863 13.602C14.6311 13.5943 14.7607 13.5235 14.8418 13.4023C15.025 13.1305 15.1832 12.8459 15.3189 12.5476C15.4496 12.253 15.2459 11.923 14.9236 11.9092C14.7388 11.9032 14.5714 12.0064 14.4945 12.1749C14.3796 12.4278 14.246 12.6679 14.0908 12.8981ZM14.9219 10.5786C14.9056 10.7562 14.9919 10.9226 15.1455 11.0128C15.4335 11.1765 15.7887 10.9933 15.8225 10.6639C15.8535 10.3372 15.8584 10.0137 15.8361 9.6862C15.8249 9.52888 15.734 9.3902 15.5941 9.31679C15.2804 9.1541 14.9087 9.39743 14.9336 9.7496C14.9527 10.0274 14.9483 10.3013 14.9219 10.5786ZM14.5472 8.14584C14.6486 8.37961 14.9206 8.48472 15.152 8.37798C15.375 8.27543 15.475 8.01416 15.3783 7.78854C15.2501 7.48812 15.0958 7.19934 14.9194 6.92432C14.6977 6.58357 14.1761 6.68286 14.0955 7.08164C14.0733 7.19888 14.0943 7.31331 14.1589 7.41423C14.3085 7.64777 14.4386 7.89063 14.5472 8.14584Z"
            fill="white"
          />
        </svg>
      );
    } else if (returnSvg === "Overdue") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM10.28 9.22C10.2113 9.14631 10.1285 9.08721 10.0365 9.04622C9.94454 9.00523 9.84522 8.98318 9.74452 8.98141C9.64382 8.97963 9.54379 8.99816 9.4504 9.03588C9.35701 9.0736 9.27218 9.12974 9.20096 9.20096C9.12974 9.27218 9.0736 9.35701 9.03588 9.4504C8.99816 9.54379 8.97963 9.64382 8.98141 9.74452C8.98318 9.84522 9.00523 9.94454 9.04622 10.0365C9.08721 10.1285 9.14631 10.2113 9.22 10.28L10.94 12L9.22 13.72C9.14631 13.7887 9.08721 13.8715 9.04622 13.9635C9.00523 14.0555 8.98318 14.1548 8.98141 14.2555C8.97963 14.3562 8.99816 14.4562 9.03588 14.5496C9.0736 14.643 9.12974 14.7278 9.20096 14.799C9.27218 14.8703 9.35701 14.9264 9.4504 14.9641C9.54379 15.0018 9.64382 15.0204 9.74452 15.0186C9.84522 15.0168 9.94454 14.9948 10.0365 14.9538C10.1285 14.9128 10.2113 14.8537 10.28 14.78L12 13.06L13.72 14.78C13.7887 14.8537 13.8715 14.9128 13.9635 14.9538C14.0555 14.9948 14.1548 15.0168 14.2555 15.0186C14.3562 15.0204 14.4562 15.0018 14.5496 14.9641C14.643 14.9264 14.7278 14.8703 14.799 14.799C14.8703 14.7278 14.9264 14.643 14.9641 14.5496C15.0018 14.4562 15.0204 14.3562 15.0186 14.2555C15.0168 14.1548 14.9948 14.0555 14.9538 13.9635C14.9128 13.8715 14.8537 13.7887 14.78 13.72L13.06 12L14.78 10.28C14.8537 10.2113 14.9128 10.1285 14.9538 10.0365C14.9948 9.94454 15.0168 9.84522 15.0186 9.74452C15.0204 9.64382 15.0018 9.54379 14.9641 9.4504C14.9264 9.35701 14.8703 9.27218 14.799 9.20096C14.7278 9.12974 14.643 9.0736 14.5496 9.03588C14.4562 8.99816 14.3562 8.97963 14.2555 8.98141C14.1548 8.98318 14.0555 9.00523 13.9635 9.04622C13.8715 9.08721 13.7887 9.14631 13.72 9.22L12 10.94L10.28 9.22Z"
            fill="#F04438"
          />
        </svg>
      );
    }
    // else{
    //   return ("pend")
    // }
  };

  const sortByColumn = (col) => {
    if (col === "Name" || col === "Branch" || col === "College") {
      let orderBy = "ASC";
      if (getCol(col) === sortby) {
        orderBy = orderby === "ASC" ? "DESC" : "ASC";
      }
      col === "Name"
        ? setSortby("name")
        : col === "Branch"
          ? setSortby("branch")
          : setSortby("college");

      setOrderby(orderBy);
    }
  };

  // Build API parameters
  const buildParams = (searchValue = "") => {
    let params = {
      type: Props.data.type,
      offset: page,
      sortby,
      orderby,
    };

    if (Props.batchDashboard) {
      params.batchId = Props.batchId; // Use actual batchId from props

      // Add date filters if dates are selected
      if (startDate && endDate) {
        params.startDate = format(startDate, "yyyy-MM-dd");
        params.endDate = format(endDate, "yyyy-MM-dd HH:mm:ss");
      }

      if (!params.startDate) {
        params.startDate = Props.batchStartDate;
        params.endDate = format(new Date(), "yyyy-MM-dd HH:mm:ss");
        setDateRange({ value: "fromStart", label: "From Start" });
      }

      // Add other filters
      if (college && college?.value !== 0) params.college = college?.label;
      if (branch && branch?.value !== 0) params.branch = branch?.label;
      if (limit) params.limit = limit;

      if (
        parseInt(Props.data.type) === 4 &&
        assignmentIds &&
        assignmentIds.length > 0
      )
        params.assignmentIds = JSON.stringify(assignmentIds);
      // ADD search parameter
      if (searchValue && searchValue.trim()) {
        params.search = searchValue.trim();
      }
    }

    return params;
  };

  // Reset page to 1 when filters change - NEW FUNCTION
  // const resetPageOnFilterChange = () => {
  //   setPage(1);
  // };

  // Effect to reset page when filters change
  // useEffect(() => {
  //   resetPageOnFilterChange();
  // }, [startDate, endDate, college, branch, assignmentIds]);

  // UPDATED: Unified data fetching function
  const fetchWidgetData = async (searchValue = "") => {
    setIsLoading(true);

    try {
      const params = buildParams(searchValue);

      let response = await axios.get(
        !Props.batchDashboard
          ? `node/admin/dashboard/${Props.dashboardId}/widget/${Props.data.wid}/report`
          : `node/admin/batch/dashboard/report`,
        { params }
      );

      if (response?.data?.data != undefined) {
        setWidgetData(response?.data?.data?.data);
        console.log("response?.data?.data?.learnersTotalCount", response?.data?.data);
        setDataTotalCount(response?.data?.data?.learnersTotalCount);

        let typeOfOrientation =
          response?.data?.data?.orientation == constants.ORIENTATION.LANDSCAPE
            ? "landscape"
            : "portrait";
        setOrientation(typeOfOrientation);

        updateColumns(
          response?.data?.data?.data[0],
          response?.data?.data?.headers
        );
      }
    } catch (err) {
      console.error("Error in getting data:", err);
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: err.message,
      });
      // throw err;
    } finally {
      setIsLoading(false);
      setFiltersApplied(false);
      Props.setRefresh(false);
      setFiltersProcessed(true);
      if (!college) setCollege({ label: "All", value: 0 });//setting default value after data fetch
    }
  };

  // UPDATED: Main data fetching useEffect
  useEffect(() => {
    if (!filtersApplied && Props.batchDashboard) {
      return;
    }

    fetchWidgetData(debouncedSearchTerm);
  }, [
    page,
    Props.data.type,
    Props.data.wid,
    Props.batchId,
    Props.refresh,
    sortby,
    orderby,
    filtersApplied,
    debouncedSearchTerm,
  ]);

  //  const getCol = (col) => {
  //   if (col == "Name") {
  //     return "name";
  //   } else if (col == "Email address") {
  //     return "email";
  //   } else if (col == "Branch") {
  //     return "branch";
  //   } else if (col == "College") {
  //     return "college";
  //   } else if (col == "Completed") {
  //     return "completedCount";
  //   } else if (col == "Pending") {
  //     return "pendingCount";
  //   } else if (col == "Overdue") {
  //     return "dueDateCount";
  //   } else if (col == "Selected range(%)") {
  //     return "percentage_selected_duration";
  //   } else if (col == "From Start(%)") {
  //     return "percentage_total_duration";
  //   } else return col;
  // };

  const handleNext = () => {
    let totalPageCount = Math.ceil(totalDataCount / limit);
    setFiltersApplied(true);
    setPage((prev) => Math.min(prev + 1, totalPageCount));
  };

  const handlePrevious = () => {
    setFiltersApplied(true);
    setPage((prev) => Math.max(prev - 1, 1));
  };

  const updateColumns = (columnfromResponse, headers) => {
    // ... your existing updateColumns logic
    const columns1 = [];
    const columns2 = [];
    const columns3 = [];
    let hederCol = [];

    if (columnfromResponse?.hasOwnProperty("name")) {
      columns1.push("Name");
    }
    if (columnfromResponse?.hasOwnProperty("email")) {
      columns1.push("Email address");
    }
    if (columnfromResponse?.hasOwnProperty("branch")) {
      columns1.push("Branch");
    }
    if (columnfromResponse?.hasOwnProperty("college")) {
      columns1.push("College");
    }

    for (let i = 0; i < headers.length; i++) {
      let afterreplace = headers[i].replace("\\n", "\n");
      columns2.push(afterreplace);
      let lastUnderscoreIndex = afterreplace.lastIndexOf("_"); // Find the last underscore
      let finalname = afterreplace.substring(0, lastUnderscoreIndex);
      hederCol.push(finalname);
    }

    let additionalarr = [];
    if (columnfromResponse?.hasOwnProperty("completedCount")) {
      columns3.push("Completed");
    }
    if (columnfromResponse?.hasOwnProperty("pendingCount")) {
      columns3.push("Pending");
    }
    if (columnfromResponse?.hasOwnProperty("dueDateCount")) {
      columns3.push("Overdue");
    }
    if (columnfromResponse?.hasOwnProperty("no_percentage")) {
      Alert.setNoPercentile(false);
    } else {
      Alert.setNoPercentile(true);
    }
    if (columnfromResponse?.hasOwnProperty("percentage_total_duration")) {
      additionalarr.push("From Start(%)");
      columns3.push("From Start(%)");
    }
    if (columnfromResponse?.hasOwnProperty("percentage_selected_duration")) {
      additionalarr.push("Selected range(%)");
      columns3.push("Selected range(%)");
    }

    setWidgetColumns1(columns1);
    setWidgetColumns2(columns2);
    setHeaderColumns(hederCol);
    setWidgetColumns3(columns3);
  };

  const columnsToShow = Props.batchDashboard
    ? getVisibleColumns()
    : widgetColumns1;

  if ((college?.value === 0 || !college) && branch) {
    setBranch(null);
  }

  return (
    <div className={isLoading ? "attendanceContainer_loading" : "attendanceContainer"}>
      <div className="boardHeader">
        <div className="leaderBoardwidgetNamendDescription">
          {/* <div>
          <text id="leaderboardText1"> {Props?.data?.name}</text>
            {Props?.data?.description && (
              <text id="leaderboardText2"> {Props?.data?.description}</text>
            )}
          </div> */}
          {/* ADDED: Search Bar at the top */}
          <div
            className="searchContainer"
            style={{ width: "100%", maxWidth: "180px" }}
          >
            <Search
              placeholder="Search Student"
              value={searchTerm}
              width={"200px"}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // setPage(1);
              }}
              iconPosition="end"
            />
          </div>
          {Props?.batchDashboard && (
            <div className="leaderBoardFilters">
              {parseInt(Props.data.type) !==
                constants.BOARD_WIDGETS.ASSIGNMENT_STATUS && (
                  <div className="dateRange">
                    <div className="attendanceFormSelect">
                      <InputDropdown
                        options={dateRanges}
                        placeholder="Date"
                        value={dateRange?.value ?? ""}
                        onChange={(selectedValue) => {
                          const selectedOption = dateRanges.find(
                            (item) => item.value === selectedValue
                          );

                          handleInputChange(selectedOption, "dateRange");
                        }}
                        className="date-range-dropdown"
                      />
                    </div>

                    <Popover
                      open={Boolean(anchorE2)}
                      anchorEl={anchorE2}
                      onClose={handleSettingClose}
                      anchorOrigin={{
                        vertical: "center",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "center",
                        horizontal: "center",
                      }}
                    >
                      <div style={{ padding: "16px 16px 0px 16px" }}>
                        <strong>Selected Dates:</strong>
                      </div>

                      <div className="startandenddatePicker">
                        {/* Selected Dates Display */}

                        <Form.Group className="mb-3">
                          <Form.Label id="batchStartDateLabel">
                            <strong>Start Date:</strong>{" "}
                            {startDate
                              ? startDate.toLocaleDateString()
                              : "Not selected"}
                          </Form.Label>
                          <DatePicker
                            name="startDate"
                            selected={startDate} // Date object
                            onChange={(date) =>
                              handleInputChange(date, "startDate")
                            }
                            autoComplete="off"
                            minDate={
                              Props.batchDashboard
                                ? new Date(Props.batchStartDate)
                                : new Date()
                            }
                            maxDate={new Date()}
                            dateFormat="dd/MM/yyyy"
                            className="batchStartDate"
                            placeholderText="Start Date..."
                            inline
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label id="batchStartDateLabel">
                            <strong>End Date:</strong>{" "}
                            {endDate
                              ? endDate.toLocaleDateString()
                              : "Not selected"}
                          </Form.Label>
                          <DatePicker
                            name="endDate"
                            selected={endDate} // Date object
                            onChange={(date) =>
                              handleInputChange(date, "endDate")
                            }
                            autoComplete="off"
                            minDate={
                              startDate ||
                              (Props.batchDashboard
                                ? new Date(Props.batchStartDate)
                                : new Date())
                            }
                            maxDate={new Date()}
                            dateFormat="dd/MM/yyyy"
                            className="batchStartDate"
                            placeholderText="End Date..."
                            inline
                          />
                        </Form.Group>
                      </div>
                      {/* Action Buttons */}
                      <div
                        className="datePickerActions"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "12px",
                          padding: "0 16px 12px 16px",
                        }}
                      >
                        <Button
                          size={"sm"}
                          onClick={handleCancelClose}
                          hierarchy={{
                            type: "secondaryGrey",
                            buttonText: "Cancel",
                          }}
                        />

                        <Button
                          size={"sm"}
                          disable={
                            dateRange &&
                            dateRange.value === "custom" &&
                            (!startDate || !endDate)
                          }
                          hierarchy={{
                            type: "primary",
                            buttonText: "Apply",
                          }}
                          onClick={handleApplyClose}
                        />
                      </div>
                    </Popover>
                  </div>
                )}

              {parseInt(Props.data.type) ===
                constants.BOARD_WIDGETS.ASSIGNMENT_STATUS && (
                  <TreeSelect
                    style={{ width: 150 }}
                    value={value}
                    popupMatchSelectWidth={false} // ✅ replaces dropdownStyle width
                    listHeight={400} // ✅ replaces dropdownStyle height
                    treeData={testList}
                    placeholder="Assignments"
                    treeCheckable={true}
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    onChange={handleChange}
                    maxTagCount="responsive"
                  />
                )}

              {getDataFromStorage("role") !== constants.Roles.hr && (
                <div className="collegeList">
                  <InputDropdown
                    options={collegeList}
                    placeholder="College"
                    value={college?.value ?? ""}
                    disabled={
                      !collegeList?.length
                    }
                    onChange={(selectedValue) => {
                      const selectedOption = collegeList.find(
                        (item) => item.value === selectedValue
                      );

                      handleInputChange(selectedOption, "college");
                    }}
                    className="college-dropdown"
                  />
                </div>
              )}

              <div className="branchList">
                <InputDropdown
                  options={branchList}
                  placeholder="Branch"
                  value={branch?.value ?? ""}
                  disabled={
                    !college ||
                    !branchList ||
                    branchList.length === 0 ||
                    college?.value === 0
                  }
                  onChange={(selectedValue) => {
                    const selectedOption = branchList.find(
                      (item) => item.value === selectedValue
                    );

                    handleInputChange(selectedOption, "branch");
                  }}
                  className="branch-dropdown"
                />
              </div>

              {/* Add Apply Filter and Reset Buttons */}
              <div
                className="filter-buttons"
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Button
                  size={"sm"}
                  disable={isLoading}
                  hierarchy={{
                    type: "primary",
                    buttonText: isLoading ? "Applying..." : "Apply Filters",
                  }}
                  onClick={handleApplyFilters}
                />

                <Button
                  size={"sm"}
                  onClick={handleResetFilters}
                  hierarchy={{
                    type: "secondaryGrey",
                    buttonText: "Reset",
                  }}
                />

                {/* {!filtersApplied && (
                <span style={{ 
                  color: '#ff9800', 
                  fontSize: '12px', 
                  marginLeft: '8px',
                  fontStyle: 'italic'
                }}>
                  Filters not applied
                </span>
              )} */}
              </div>

              <>
                <IconButton
                  onClick={handleSettingsClick}
                  size="small"
                  sx={{ ml: 0 }}
                  aria-label="column settings"
                >
                  <Tooltip title="Hide/Show Columns">
                    <Columns3 />
                  </Tooltip>
                </IconButton>

                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleSettingsClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <div style={{ padding: "16px" }}>
                    <h5 style={{ margin: "0 0 12px 0" }}>Display Columns</h5>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.name}
                            onChange={() => handleToggleColumn("name")}
                          />
                        }
                        label="Name"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.email}
                            onChange={() => handleToggleColumn("email")}
                          />
                        }
                        label="Email"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.branch}
                            onChange={() => handleToggleColumn("branch")}
                          />
                        }
                        label="Branch"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.college}
                            onChange={() => handleToggleColumn("college")}
                          />
                        }
                        label="College"
                      />
                    </FormGroup>
                  </div>
                </Popover>
              </>
            </div>
          )}
        </div>
        {downloadWidget == Props.data.wid && !Props.batchDashboard && (
          <span className="downloadSingleWidgetAlert">
            Download in Progress,Please Wait...
          </span>
        )}

        <div className="downloadDropdown">
          {showDownloadOptionsDropDown && (
            <div
              onMouseLeave={() => {
                setShowDownloadOptionsDropDown(false);
              }}
            >
              <DownloadOptions
                name={Props?.data?.name}
                type={Props.data.type}
                dashboardId={Props.dashboardId}
                widgetId={Props.data.wid}
                orientation={orientation}
                batchDashboard={Props.batchDashboard}
                batchId={Props.batchId}
                batchStartDate={Props.batchStartDate}
                startDate={Props.data.type === constants.BOARD_WIDGETS.ATTENDANCE ? appliedFilters.startDate : null}
                endDate={Props.data.type === constants.BOARD_WIDGETS.ATTENDANCE ? appliedFilters.endDate : null}
                college={
                  appliedFilters.college?.value !== 0
                    ? appliedFilters.college?.label
                    : null
                }
                branch={
                  appliedFilters.branch?.value !== 0
                    ? appliedFilters.branch?.label
                    : null
                }
                assignmentIds={
                  appliedFilters.assignmentIds.length > 0
                    ? JSON.stringify(appliedFilters.assignmentIds)
                    : null
                }
                search={debouncedSearchTerm?.trim()}
              />{" "}
            </div>
          )}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setShowDownloadOptionsDropDown(true)}
            className="boarddownloadicon"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6577 12.5V15.8333C17.6577 16.2754 17.4821 16.6993 17.1696 17.0118C16.857 17.3244 16.4331 17.5 15.991 17.5H4.32438C3.88235 17.5 3.45843 17.3244 3.14587 17.0118C2.83331 16.6993 2.65771 16.2754 2.65771 15.8333V12.5M5.99105 8.33333L10.1577 12.5M10.1577 12.5L14.3244 8.33333M10.1577 12.5V2.5"
                stroke="#344054"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.78205 0.799874L4.04042 5.53542C3.8889 5.79714 3.81313 5.928 3.71429 5.97195C3.62807 6.01029 3.52964 6.01029 3.44342 5.97195C3.34458 5.928 3.26882 5.79714 3.1173 5.53542L0.375669 0.799876C0.2236 0.537211 0.147566 0.40588 0.158804 0.298091C0.168606 0.204075 0.217862 0.118642 0.294315 0.0630541C0.381968 -0.000677109 0.533722 -0.000677109 0.837229 -0.000677109L6.32049 -0.000677109C6.62399 -0.000677109 6.77575 -0.000677109 6.8634 0.0630541C6.93985 0.118642 6.98911 0.204075 6.99891 0.298091C7.01015 0.40588 6.93412 0.537211 6.78205 0.799874Z"
                fill="#667085"
              />
            </svg>
          </span>
          {/* <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowWidgetDropDown(true);
            }}
            className="columnoptions"
          >
            <svg
              width="4"
              height="16"
              viewBox="0 0 4 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.5 2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5C2.39782 0.5 2.77936 0.658035 3.06066 0.93934C3.34196 1.22064 3.5 1.60218 3.5 2C3.5 2.39782 3.34196 2.77936 3.06066 3.06066C2.77936 3.34196 2.39782 3.5 2 3.5C1.60218 3.5 1.22064 3.34196 0.93934 3.06066C0.658035 2.77936 0.5 2.39782 0.5 2ZM0.5 8C0.5 7.60218 0.658035 7.22064 0.93934 6.93934C1.22064 6.65804 1.60218 6.5 2 6.5C2.39782 6.5 2.77936 6.65804 3.06066 6.93934C3.34196 7.22064 3.5 7.60218 3.5 8C3.5 8.39782 3.34196 8.77936 3.06066 9.06066C2.77936 9.34196 2.39782 9.5 2 9.5C1.60218 9.5 1.22064 9.34196 0.93934 9.06066C0.658035 8.77936 0.5 8.39782 0.5 8ZM0.5 14C0.5 13.6022 0.658035 13.2206 0.93934 12.9393C1.22064 12.658 1.60218 12.5 2 12.5C2.39782 12.5 2.77936 12.658 3.06066 12.9393C3.34196 13.2206 3.5 13.6022 3.5 14C3.5 14.3978 3.34196 14.7794 3.06066 15.0607C2.77936 15.342 2.39782 15.5 2 15.5C1.60218 15.5 1.22064 15.342 0.93934 15.0607C0.658035 14.7794 0.5 14.3978 0.5 14Z"
                fill="black"
              />
            </svg>
          </span> */}
        </div>
      </div>

      {isLoading && <Loading overlay />}
      {!isLoading &&
        <div className="tableContainer">
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead style={{ background: "#f9fafb" }}>
                <TableRow>
                  {widgetData.length > 0 &&
                    columnsToShow.map((column, ind) => (
                      <TableCell
                        rowSpan={2}
                        onClick={() => {
                          sortByColumn(column);
                        }}
                        className={
                          column == "Name"
                            ? classes.stickyCellname1
                            : column == "Email address"
                              ? classes.stickyCellemail1
                              : column == "Branch"
                                ? classes.stickyCellbranch1
                                : column == "College"
                                  ? classes.stickyCellcollege1
                                  : classes.na
                        }
                        title={column}
                        key={ind}
                        align="left"
                      >
                        {column}
                      </TableCell>
                    ))}

                  {widgetData.length > 0 &&
                    headerColumns.map((col, ind) => (
                      <TableCell
                        // rowSpan={2}
                        colSpan={1}
                        onClick={() => {
                          sortByColumn(col);
                        }}
                        className={classes.nah}
                        title={col.split("\n")[0]}
                        key={ind}
                        align="center"
                      >
                        {col.split("\n")[0]}
                      </TableCell>
                    ))}

                  {widgetData.length > 0 &&
                    Props.data.type ==
                    constants.BOARD_WIDGETS.ASSIGNMENT_STATUS && (
                      <TableCell
                        colSpan={3}
                        align="center"
                        className={classes.combined2}
                      >
                        Assignments
                      </TableCell>
                    )}

                  {widgetData.length > 0 && Alert.noPercentile && (
                    <TableCell
                      colSpan={2}
                      align="center"
                      className={classes.combined1}
                    >
                      {Props.data.type ==
                        constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                        ? "Assignment Percentage"
                        : "Percentage"}
                    </TableCell>
                  )}
                </TableRow>
                <TableRow>
                  {widgetData.length > 0 &&
                    headerColumns.map((col, ind) => (
                      <TableCell
                        // rowSpan={2}
                        // colSpan={1}
                        // onClick={() => {
                        //   sortByColumn(col);
                        // }}
                        className={classes.nah}
                        title={col.split("\n")[1]}
                        key={ind}
                        align="center"
                      >
                        {col.split("\n")[1]}
                      </TableCell>
                    ))}
                  {widgetData.length > 0 &&
                    widgetColumns3.map((column, ind) => (
                      <TableCell
                        onClick={() => {
                          sortByColumn(column);
                        }}
                        className={
                          column == "Completed"
                            ? classes.stickyCellcompleted1
                            : column == "Pending"
                              ? classes.stickyCellpending1
                              : column == "Overdue"
                                ? classes.stickyCelloverdue1
                                : column == "From Start(%)"
                                  ? classes.stickyCellTotal1
                                  : column == "Selected range(%)"
                                    ? classes.stickyCellSelected1
                                    : classes.na
                        }
                        title={column}
                        key={ind}
                        align="center"
                      >
                        {column}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {widgetData.length > 0 ? (
                  widgetData.map((row, rowIndex) => (
                    <TableRow key={row.id}>
                      {/* {widgetColumns.map((column, colIndex) => (
                      <TableCell
                        align={
                          column == "Name" ||
                          column == "Branch" ||
                          column == "College" ||
                          column == "Email address"
                            ? "left"
                            : "center"
                        }
                        className={
                          column == "Name"
                            ? classes.stickyCellname
                            : column == "Email address"
                            ? classes.stickyCellemail
                            : column == "Branch"
                            ? classes.stickyCellbranch
                            : column == "College"
                            ? classes.stickyCellcollege
                            : column == "Completed"
                            ? classes.stickyCellcompleted
                            : column == "Pending"
                            ? classes.stickyCellpending
                            : column == "Overdue"
                            ? classes.stickyCelloverdue
                            : column == "From Start(%)"
                            ? classes.stickyCellTotal
                            : column == "Selected range(%)"
                            ? classes.stickyCellSelected
                            : classes.na
                        }
                        key={colIndex}
                        title={
                          typeof row[column.replace("\n", "\\n")] === "object"
                            ? Props.data.type ==
                              constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                              ? getStatus(
                                  row[column].status,
                                  row[column].libtype,
                                  row[column].duedate
                                )
                              : getAtt(row[column.replace("\n", "\\n")].status)
                            : row[getCol(column)]
                        }
                      >
                        {typeof row[column.replace("\n", "\\n")] === "object"
                          ? Props.data.type ==
                            constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                            ? getStatus(
                                row[column].status,
                                row[column].libtype,
                                row[column].duedate
                              )
                            : getAtt(row[column.replace("\n", "\\n")].status)
                          : row[getCol(column)]}
                      </TableCell>
                    ))} */}

                      {/* {columnsToShow.map((column, colIndex) => (
                        
                        <TableCell
                          align="left"
                          key={colIndex}
                          className={
                            column == "Name"
                              ? classes.stickyCellname
                              : column == "Email address"
                              ? classes.stickyCellemail
                              : column == "Branch"
                              ? classes.stickyCellbranch
                              : column == "College"
                              ? classes.stickyCellcollege
                              : classes.na
                          }
                          title={
                            typeof row[column.replace("\n", "\\n")] === "object"
                              ? Props.data.type ==
                                constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                                ? getStatus(
                                    row[column]?.status,
                                    row[column].libtype,
                                    row[column].duedate
                                  )
                                : getAtt(
                                    row[column.replace("\n", "\\n")].status
                                  )
                              : row[getCol(column)]
                          }
                        >
                          {typeof row[column.replace("\n", "\\n")] === "object"
                            ? Props.data.type ==
                              constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                              ? getStatus(
                                  row[column].status,
                                  row[column].libtype,
                                  row[column].duedate
                                )
                              : getAtt(row[column.replace("\n", "\\n")].status)
                            : row[getCol(column)]}
                        </TableCell>
                      ))} */}

                      {columnsToShow.map((column, colIndex) => {
                        if (column === "Name") {
                          return (
                            <UserReportProvider key={colIndex}>
                              <NameCell
                                row={{
                                  ...row,
                                  Name: row.name, 
                                  learnerid: row.id, 
                                }}
                                rowIndex={rowIndex}
                                className={classes.stickyCellname}
                                pos="batch-report-page-container"
                              />
                            </UserReportProvider>
                          );
                        }

                        return (
                          <TableCell
                            key={colIndex}
                            align="left"
                            className={
                              column === "Email address"
                                ? classes.stickyCellemail
                                : column === "Branch"
                                  ? classes.stickyCellbranch
                                  : column === "College"
                                    ? classes.stickyCellcollege
                                    : classes.na
                            }
                            title={
                              typeof row[column.replace("\n", "\\n")] === "object"
                                ? Props.data.type === constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                                  ? getStatus(
                                    row[column]?.status,
                                    row[column]?.libtype,
                                    row[column]?.duedate
                                  )
                                  : getAtt(row[column.replace("\n", "\\n")].status)
                                : row[getCol(column)]
                            }
                          >
                            {typeof row[column.replace("\n", "\\n")] === "object"
                              ? Props.data.type === constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                                ? getStatus(
                                  row[column]?.status,
                                  row[column]?.libtype,
                                  row[column]?.duedate
                                )
                                : getAtt(row[column.replace("\n", "\\n")].status)
                              : row[getCol(column)]}
                          </TableCell>
                        );
                      })}

                      {widgetColumns2.map((column, colIndex) => (
                        <TableCell
                          align="center"
                          key={colIndex}
                          className={classes.na}
                          title={
                            typeof row[column.replace("\n", "\\n")] === "object"
                              ? Props.data.type ==
                                constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                                ? getStatusForTitle(
                                  row[column]?.status,
                                  row[column]?.libtype,
                                  row[column]?.duedate
                                )
                                : getAttForTitle(
                                  row[column.replace("\n", "\\n")]?.status
                                )
                              : row[getCol(column)]
                          }
                        >
                          {row[column.replace("\n", "\\n")] == undefined ? (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                fill="#667085"
                              />
                              <path
                                d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                                stroke="white"
                                stroke-width="1.67"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          ) : typeof row[column.replace("\n", "\\n")] ===
                            "object" ? (
                            Props.data.type ==
                              constants.BOARD_WIDGETS.ASSIGNMENT_STATUS ? (
                              getStatus(
                                row[column]?.status,
                                row[column]?.libtype,
                                row[column]?.duedate
                              )
                            ) : (
                              getAtt(row[column.replace("\n", "\\n")]?.status)
                            )
                          ) : (
                            row[getCol(column)]
                          )}
                        </TableCell>
                      ))}

                      {widgetColumns3.map((column, colIndex) => (
                        <TableCell
                          align="center"
                          key={colIndex}
                          className={
                            column == "Completed"
                              ? classes.stickyCellcompleted
                              : column == "Pending"
                                ? classes.stickyCellpending
                                : column == "Overdue"
                                  ? classes.stickyCelloverdue
                                  : column == "From Start(%)"
                                    ? classes.stickyCellTotal
                                    : column == "Selected range(%)"
                                      ? classes.stickyCellSelected
                                      : classes.na
                          }
                          title={
                            typeof row[column.replace("\n", "\\n")] === "object"
                              ? Props.data.type ==
                                constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                                ? getStatus(
                                  row[column].status,
                                  row[column].libtype,
                                  row[column].duedate
                                )
                                : getAtt(
                                  row[column.replace("\n", "\\n")].status
                                )
                              : row[getCol(column)]
                          }
                        >
                          {typeof row[column.replace("\n", "\\n")] === "object"
                            ? Props.data.type ==
                              constants.BOARD_WIDGETS.ASSIGNMENT_STATUS
                              ? getStatus(
                                row[column].status,
                                row[column].libtype,
                                row[column].duedate
                              )
                              : getAtt(row[column.replace("\n", "\\n")].status)
                            : row[getCol(column)]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow
                    align="center"
                    style={{
                      height: "450px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {!filtersApplied && !filtersProcessed ? (
                      <ApplyFilters
                        type={Props.data.type}
                        text={`Choose ${Props.data.type === 1 ? "a Date" : ""
                          } ${Props.data.type !== 1 ? " Assignment(s)" : ""
                          } from the filters above and hit Apply to load the ${Props.data.name
                          } Report.`}
                      />
                    ) : (
                      filtersProcessed && (
                        <ApplyFilters text="No data available for the selected filters. Try changing the filter options or click Reset." />
                      )
                    )}
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      }

      <div className="boardFooter">
        {/* <Pagination
          count={Math.ceil(totalDataCount / 10)}
          variant="outlined"
          color="primary"
          page={page}
          onChange={onpaginationChange}
        /> */}
        {!isLoading && widgetData.length > 0 && (
          <PaginationCustom
            totalPages={Math.ceil(totalDataCount / limit)}
            currentPage={page}
            setCurrentPage={setPage}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            setFiltersApplied={setFiltersApplied}
            batchDashboard={Props.batchDashboard}
          />
        )}
      </div>
    </div>
  );
};

export default Attendance;
